import script from "./PeriodontalChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./PeriodontalChart.vue?vue&type=script&setup=true&lang=ts"

import "./PeriodontalChart.vue?vue&type=style&index=0&id=b17ce672&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b17ce672"]])

export default __exports__